import React from 'react';
import { render } from 'react-dom';
import { getBaseUrl, setBaseUrl, setErrorHandler, setOrigin } from '@ecster/net';

import { createOriginString } from '@ecster/util';

import { initI18n } from '@ecster/i18n';
import { detectDevice, IsKeyboardVisible } from '@ecster/components';
import configStore, { history } from './common/configStore';
import routeConfig from './common/routeConfig';
import Root from './Root';
import Gateway from './common/Gateway';
import addDeviceClass from './common/util/add-device-class';

import './styles/tailwind.css';
import './styles/index.scss';
import { initBackForwardCacheBuster } from './common/util/back-forward-cache';
import { cache } from './common/cacheHandler';
import { createOriginCookie, getOriginCookie } from './common/OriginCookie';
import { fetchConfig, setConfig } from './common/MyPagesConfig.jsx';

const isLoginOrLogoutPage = () =>
    window.location.hash === '#/' ||
    window.location.hash === '#/authentication/logout' ||
    window.location.hash === '#/start';

export const store = configStore();

const App = async ({ store, routeConfig, conf }) => {
    const typeOfDevice = addDeviceClass(); // Adds a corresponding CSS class to the HTML element, depending on type of device used.

    let App;

    document.querySelector('html').setAttribute('lang', 'sv-SE');

    if (typeOfDevice === 'MOBILE') {
        App = (
            <>
                <Gateway config={conf} App={<Root store={store} routeConfig={routeConfig} />} />
                <IsKeyboardVisible />
            </>
        );
    } else {
        App = <Gateway config={conf} App={<Root store={store} routeConfig={routeConfig} />} />;
    }

    render(App, document.getElementById('react-root'));
};

async function loadTranslations() {
    const res = await fetch('./static/i18n/sv-SE.json');
    const data = await res.json();

    initI18n(data);
}

const initApplication = async () => {
    const conf = window.EcsterConfig;
    conf.applicationCountry = 'SE';

    const { isMobile, isTablet, isDesktop } = detectDevice();
    const originId = getOriginCookie() || createOriginCookie();

    setOrigin(createOriginString('mypages', isMobile, isTablet, isDesktop, window, originId));
    window.sessionStorage.setItem('initialBaseUrl', conf.baseURL);

    if (conf) {
        // 2025-03-17: varför sätter vi om conf.baseUrl om baseUrl redan finns i session storage??
        // normal-case är att sätta värdet från conf i session storage
        const baseUrl = getBaseUrl();
        if (baseUrl) {
            conf.baseURL = baseUrl;
        } else if (conf.baseURL) {
            const { baseURL } = conf;
            setBaseUrl(baseURL);
        }
    }

    setErrorHandler(error => {
        if (error?.status === 401 && !isLoginOrLogoutPage()) history.push('/authentication/logout');
    });

    initBackForwardCacheBuster();

    await loadTranslations();

    const myPagesConfig = await fetchConfig();
    setConfig(myPagesConfig);
    App({ store, routeConfig, conf });
    cache.init();
    console.info('Application is initialized.');
};

(async () => await initApplication())(); // NOSONAR
